module.exports = __webpack_public_path__ + "static/media/券商投资升级@2x.7a55b15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/券商投资升级@2x.png
// module id = 1585
// module chunks = 0